import type { SelectedFile } from '../../../components/forms/FileUpload';
import type { SavedAttachment } from '../../../services/attachmentService';
import type { Request } from '../../../types';

export interface SiteInformationInitialProps {
  formData: Record<string, unknown>;
  updateFormData: (field: string, value: string | number | boolean) => void;
  requestId?: string;
  disabled?: boolean;
  attachmentsBySection?: Record<string, SavedAttachment[]>;
  onAttachFiles?: (sectionId: string) => void;
  onDeleteAttachment?: (attachmentId: number) => void;
  isEditing?: boolean;
  selectedFiles?: Record<string, SelectedFile[]>;
  onFilesSelected?: (sectionId: string, files: SelectedFile[]) => void;
  offlineMode?: boolean;
  showFullDetails?: boolean;
}

export interface SiteInformationPersistedProps {
  request: Request;
  isEditing: boolean;
  editedData: Record<string, unknown>;
  updateEditedData: (field: string, value: string) => void;
  showFullDetails?: boolean;
  showViewToggle?: boolean;
  isAdvancedView?: boolean;
  onToggleView?: () => void;
  attachmentsBySection?: Record<string, SavedAttachment[]>;
  onAttachFiles?: (sectionId: string) => void;
  onDeleteAttachment?: (attachmentId: number) => void;
  selectedFiles?: Record<string, SelectedFile[]>;
  onFilesSelected?: (sectionId: string, files: SelectedFile[]) => void;
  offlineMode?: boolean;
  onCaptionChange?: (attachmentId: number, caption: string) => void;
  pendingCaptionEdits?: Record<number, string>;
}

export type SiteInformationProps =
  | SiteInformationInitialProps
  | SiteInformationPersistedProps;

export function isSiteInformationPersistedProps(
  p: SiteInformationProps,
): p is SiteInformationPersistedProps {
  return 'request' in p && (p as SiteInformationPersistedProps).request != null;
}
